<template>
  <label v-bind="$attrs" v-on="$listeners" :class="font">
    {{ text }}
  </label>
</template>

<script>
import { labelStyle } from '@/state/helpers/mixins.js'
export default {
  computed: {
    text() {
      return this.$t(`mygwf.components.Label.${this.$attrs.text}`)
    },
  },
}
</script>
